module.exports = __webpack_public_path__ + "img/PerformanceManager_mehrfarbig_RGB.a2c7ac86.svg";